import { login, logout } from '@/api/admin'
import { getAdminProfile } from '@/api/system'
import { setToken, removeToken, setAdminInfo, removeAdminInfo, getAdminCache } from '@/utils/auth'

const state = {
  user: null,
  token: ''
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
  },
  SET_TOKEN(state, token) {
    state.token = token
  }
}

const actions = {
  async login({ commit }, data) {
    const res = await login(data)
    if (res.data) {
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER', res.data.admin)
      setToken(res.data.token)
      setAdminInfo(res.data.admin)
    }
    return res
  },
  
  async getAdminInfo({ commit }) {
    const res = await getAdminProfile()
    if (res && res.data) {
      commit('SET_USER', res.data)
      setAdminInfo(res.data)
    } else {
      // 接口异常时，从 localStorage 恢复已登录的管理员信息，避免页面空白
      const cached = getAdminCache()
      if (cached) {
        commit('SET_USER', cached)
      }
    }
    return res
  },
  
  async logout({ commit }) {
    await logout()
    commit('SET_TOKEN', '')
    commit('SET_USER', null)
    removeToken()
    removeAdminInfo()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}